import type { DataResponse, SuccessResponse } from '@/api/types';
import type { PreSignedUrlRequest } from '@views/UploadIndex/types';
import axios from 'axios';
import { gateway } from '..';

export function rateDocument(documentId: number, rate: number, reasonId?: number, comment?: string) {
    return gateway
        .post<{
            success: true;
            avg_star_score: `${number}.${number}`;
            ratings_count: number;
            hasvotes: boolean;
            has_votes: boolean;
        }>(`legacy-api/v1/documents/${documentId}/rate`, { rate, reasonId, comment })
        .then((response) => response.data);
}

export function storeDeleteReason(documentId: number, reasonId: number, comment?: string | null) {
    return gateway
        .post<DataResponse<SuccessResponse>>(`legacy-api/v1/documents/${documentId}/delete-reason`, {
            delete_reason_id: reasonId,
            comment,
        })
        .then((response) => response.data);
}

export function storeDocumentView(documentId: string) {
    return gateway.post(`legacy-api/v1/documents/${documentId}/viewed`);
}

// upload document logic
export function requestPreSignedUrlUpload(data: PreSignedUrlRequest) {
    return gateway.post('legacy-api/v1/documents/upload/request-presigned-url', data);
}

export function requestGuestPreSignedUrlUpload(data: PreSignedUrlRequest) {
    return gateway.post('legacy-api/v1/documents/upload/request-presigned-url/guest', data);
}

export function uploadFileToS3(uploadUrl: string, file: File, md5: string) {
    const s3Headers = {
        'Content-Type': file.type || 'application/octet-stream',
        'Content-MD5': md5,
    };
    return axios.put(uploadUrl, file, {
        headers: s3Headers,
    });
}

export function processDocumentUpload(uploadUUID: string) {
    return gateway.post('legacy-api/v1/documents/upload/process-temp', {
        upload_uuid: uploadUUID,
    });
}

export function processDocumentUploadGuest(uploadUUID: string, attempts: number) {
    return gateway.post('legacy-api/v1/documents/upload/process-temp/guest', {
        upload_uuid: uploadUUID,
        attempts,
    });
}
